export default __webpack_public_path__ + "static/media/jannis-lucas-UVCWILBdr-c-unsplash.f3fb5e32.jpg";